import { Button, Radio, TextArea } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';
import { useForm } from 'react-hook-form';
import { IIdCardRejectionForm, IRejectionModal } from '../../interface';

const REJECTION_REASONS = ['Incorrect Photograph', 'Unclear Photograph', 'Other'];

const RejectionModal = (props: IRejectionModal) => {
  const { closeModal, handleRejection } = props;
  const { register, handleSubmit, watch, reset } = useForm<IIdCardRejectionForm>();

  const comment = watch('comment');
  const otherComment = watch('other');
  const isOtherRadioBtnSelected = comment === 'Other';

  const handleReject = (data: IIdCardRejectionForm) => {
    let commentText = data.comment;
    if (isOtherRadioBtnSelected) {
      commentText = data.other;
    }
    handleRejection(commentText);
    handleCancel();
  };

  const handleCancel = () => {
    closeModal();
    reset();
  };

  const disableAction = !comment || (isOtherRadioBtnSelected && !otherComment);

  return (
    <div className={styles.rejectionModal}>
      {REJECTION_REASONS.map(reason => (
        <div className={styles.radioBtn} key={reason}>
          <Radio id={reason} label={reason} value={reason} {...register('comment')} />
        </div>
      ))}
      {isOtherRadioBtnSelected ? <TextArea {...register('other', { required: true })} /> : null}
      <div className={styles.buttonContainer}>
        <Button onClick={handleCancel} name={'cancel_rejection'} variant={'secondary'}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit(handleReject)}
          name={'done_reject'}
          type={'submit'}
          variant={'primary'}
          disabled={disableAction}
        >
          Done
        </Button>
      </div>
    </div>
  );
};

export default RejectionModal;
